import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    :host {
        display: block;
        --text-color: rgb(8, 8, 9);
    }

    .container {
        display: flex;
        width: 100%;
        background-color: white;
        max-width: 1024px;
        background-color: rgb(242, 244, 247);
    }

    .banner {
        display: block;
        width: 100%;
        background-color: white;
    }

    .Settings,
    .Gallery {
        padding: 1em;
    }

    @media only screen and (max-width: 600px) {
        .Gallery {
            padding: 0.5em;
        }
    }
`;
